import type { SessionType } from '../types';

export const SESSION_LABELS: Record<SessionType, string> = {
  onboarding: 'Getting Started',
  morning_checkin: 'Morning Check-In',
  evening_checkin: 'Evening Check-In',
  ad_hoc: 'Chat with Flank',
  task_planning: 'Task Planning',
  coaching: 'Coaching Call',
};
